/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderSetupPhaseState } from '../../models/production-order-setup-phase-state';

export interface GetSetupPhaseState$Params {
  productionOrderId: number;
  runId?: number | null;
  calledFromApproveReport?: boolean;
}

export function getSetupPhaseState(http: HttpClient, rootUrl: string, params: GetSetupPhaseState$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderSetupPhaseState>> {
  const rb = new RequestBuilder(rootUrl, getSetupPhaseState.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.query('runId', params.runId, {});
    rb.query('calledFromApproveReport', params.calledFromApproveReport, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderSetupPhaseState>;
    })
  );
}

getSetupPhaseState.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetSetupPhaseState';
